import axios from 'axios';
import { supabase } from './supabase';

const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production' 
    ? 'https://fbatrackify.com'
    : 'http://localhost:4000',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Intercepteur pour ajouter le token d'authentification
api.interceptors.request.use(async (config) => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (session?.access_token) {
      config.headers.Authorization = `Bearer ${session.access_token}`;
    } else {
      console.warn('Aucun token d\'authentification trouvé');
    }
    return config;
  } catch (error) {
    console.error('Erreur lors de la récupération du token:', error);
    return Promise.reject(error);
  }
});

// Intercepteur pour gérer les erreurs d'authentification
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Vérifier si nous sommes déjà sur la page d'authentification
      if (!window.location.pathname.includes('/auth')) {
        // Rediriger vers la page de connexion si le token est invalide
        window.location.href = '/auth';
      }
    }
    return Promise.reject(error);
  }
);

export default api; 